var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"adapt-box"},[_c('iframe',{staticClass:"adapt-iframe",attrs:{"src":_vm.targetUrl,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }